/**
 * Holds the password typed at sign-up *in memory only* so that, right after
 * the account is confirmed in the same tab, we can sign the user in without
 * asking for the password again.
 *
 * Deliberately not persisted anywhere (no localStorage, no history state):
 * if the tab reloads, the handoff is gone and /confirmar-conta simply sends
 * the user to /login with the e-mail prefilled.
 */
let handoff = null; // { email, password }

export const setSignupHandoff = (email, password) => { handoff = { email, password }; };

export const takeSignupHandoff = (email) => {
  const current = handoff;
  handoff = null;
  return current && current.email === email ? current : null;
};

export const clearSignupHandoff = () => { handoff = null; };
